var map = {
	"./chargingpoint-alert.png": 6292,
	"./chargingpoint-definitive.png": 6403,
	"./chargingpoint-in-progress.png": 8729,
	"./chargingpoint-realized.png": 3158,
	"./chargingpoint-rejected.png": 6874,
	"./chargingpoint-suggestion.png": 2363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9175;